/*
 * 催收统计报表
 *
 * *
 * */
import { ticketClient } from "@/api/ticketClient";
import {
    ListUrgeDetailStatsReq,
    ListUrgeDetailStatsParamReq,
    HourlyUrgeStatsReq
} from "@/pbjs/external/ticket/ticket_pb";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "./request";
export interface Options {
    itemid: number;
    id: number;
}
export function setListUrgeDetailStatsReq(arg: any) {
    let request: any = new ListUrgeDetailStatsReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setItemid(arg.Itemid);
    request.setUsergroupid(arg.Usergroupid);
    request.setUsername(arg.Username);
    request.setCalltype(arg.Calltype);
    request.setPhoneobject(arg.Phoneobject);
    request.setIsreloan(arg.Isreloan);
    request.setTicketstatus(arg.Ticketstatus);
    request.setCommunicationway(arg.Communicationway);
    request.setDimensionList(arg.DimensionList);
    request.setTimerange(arg.Timerange);
    return request;
}
export const listUrgeDetailStatsRequest = new InnerRequest(
    ticketClient,
    ticketClient.listUrgeDetailStats
);

export function setHourlyUrgeStatsReq(arg: any) {
    let request: any = new HourlyUrgeStatsReq();
    // request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setDate(arg.Date);
    request.setItemid(+arg.Itemid);
    request.setUsergroupid(arg.Usergroupid);
    request.setUsername(arg.Username);
    request.setPhoneobject(arg.Phoneobject);
    request.setIsreloan(arg.Isreloan);
    request.setTicketstatus(arg.Ticketstatus);
    request.setCommunicationway(arg.Communicationway);
    request.setDimensionList(arg.DimensionList);
    return request;
}
export const hourlyUrgeStatsRequest = new InnerRequest(
    ticketClient,
    ticketClient.hourlyUrgeStats
);

export function setListUrgeDetailStatsParamReq(arg: any) {
    let request: any = new ListUrgeDetailStatsParamReq();
    return request;
}
export const listUrgeDetailStatsParamRequest = new InnerRequest(
    ticketClient,
    ticketClient.listUrgeDetailStatsParam
);

export const listUrgeDetailStatsExcelRequest = new InnerRequest(
    ticketClient,
    ticketClient.listUrgeDetailStatsExcel
);
